














































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































import SideModalHeader from '@/components/SideModalHeader/SideModalHeader.vue';
import { Component, Vue } from 'vue-property-decorator';

@Component({
  components: {
    SideModalHeader
  }
})
export default class terms extends Vue {}
